module.exports = __webpack_public_path__ + "static/media/branch-istanbul.20dbcb84.jpg";